import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/lib/site";
import { CheckCircle2 } from "lucide-react";

const outcomes = [
  "Reduced joint pain & inflammation",
  "Improved posture and alignment",
  "Sustainable fat loss & lean muscle gain",
  "Increased mobility and stability",
  "Stronger, balanced functional strength",
  "Confidence in your body at any age",
];

export const Benefits = () => {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="relative py-20 sm:py-28 lg:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5"
        >
          <div className="relative">
            <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-[#0055FF]/30 to-[#00E5FF]/30 blur-3xl"></div>
            <img
              src={SITE.images.strength}
              alt="Strength and conditioning session with a personal trainer in Dubai"
              loading="lazy"
              decoding="async"
              className="relative rounded-[1.75rem] w-full h-[560px] object-cover ring-1 ring-white/10"
            />
            <div className="absolute -bottom-6 -right-6 glass rounded-2xl p-5 max-w-[230px] hidden md:block">
              <div className="text-xs uppercase tracking-[0.22em] text-[#00E5FF]">Outcome</div>
              <div className="font-display text-white font-bold text-lg mt-1 leading-tight">
                Stronger body. Pain-free joints.
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">Benefits & Outcomes</div>
          <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-[1.05] tracking-[-0.02em] text-white">
            Build strength <span className="text-gradient-blue">without compromising</span> joint health.
          </h2>
          <p className="mt-6 text-zinc-300/90 text-lg max-w-xl">
            Whether your goal is fat loss, posture, performance, or simply moving without
            pain, the system delivers compounding outcomes that hold long after the session ends.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {outcomes.map((o) => (
              <div
                key={o}
                className="flex items-start gap-3 p-4 rounded-xl glass glass-hover"
              >
                <CheckCircle2 className="w-5 h-5 text-[#00E5FF] mt-0.5 shrink-0" />
                <span className="text-zinc-200 text-sm">{o}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
